import { PhoneNumber } from "antd-phone-input";
import { IUserInfo, UserListEntity } from "interfaces";

export function getFio(firstName: string, secondName: string, patronymic: string) {
  let result = secondName;
  if (firstName) result += ` ${firstName[0]}.`;
  else result += ` -`;
  if (patronymic) result += ` ${patronymic[0]}.`;
  return result;
}

export function getSnils(s: string) {
  if (!(s && s.length === 11)) return s;
  return `${s[0]}${s[1]}${s[2]}-${s[3]}${s[4]}${s[5]}-${s[6]}${s[7]}${s[8]} ${s[9]}${s[10]}`;
}

export function getPhone(phoneNumber: string | number): string {
  if (!phoneNumber) return "";
  const s = phoneNumber.toString();

  if (!/^\d{11,}$/.test(s)) return s;

  const countryCode = s.slice(0, -10);
  const localNumber = s.slice(-10);

  return `+${countryCode} (${localNumber.slice(0, 3)}) ${localNumber.slice(
    3,
    6
  )}-${localNumber.slice(6, 8)}-${localNumber.slice(8)}`;
}

export function getPhoneMaskValue(value: PhoneNumber | string): string {
  if (!value) {
    return "";
  }

  if (typeof value === "string") {
    return value.replace(/\D/g, "");
  }

  const { countryCode, areaCode, phoneNumber } = value;
  const fullNumber = `${countryCode || ""}${areaCode || ""}${phoneNumber || ""}`;
  return fullNumber.replace(/\D/g, "");
}

export const getFullName = (userInfo: IUserInfo | UserListEntity | undefined): string =>
  userInfo
    ? `${userInfo.surname} ${userInfo.name} ${
        "second_name" in userInfo ? userInfo.second_name : userInfo.secondName || ""
      }`
    : "";

export function getShortName(surname: string, name: string, patronymic?: string): string {
  if (!surname || !name) return "";

  let result = surname;
  result += ` ${name[0]}.`;

  if (patronymic && patronymic.trim().length > 0) {
    result += `${patronymic[0]}.`;
  }

  return result;
}
